import { Component, OnInit } from '@angular/core';
import { PledgeRead } from '@app/forms/subscription/definition/interface/Pledge';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { HttpApiService } from '@app/providers/http-api/http-api.service';

@Component({
    selector: 'send-completion-subscription-email',
    templateUrl: './send-completion-subscription-email.component.html',
    styleUrls: ['./send-completion-subscription-email.component.scss'],
    standalone: false
})
export class SendCompletionSubscriptionEmailComponent implements OnInit {
  pledge: PledgeRead;
  autologinUrl: string;
  loading = false;

  constructor(
    private subscriptionFacade: SubscriptionFacadeService,
    private httpApiService: HttpApiService,
  ) {}

  ngOnInit(): void {
    this.pledge = this.subscriptionFacade.getPledge();
    this.getSendCompletionSubscriptionEmail();
  }

  getSendCompletionSubscriptionEmail() {
    // this.loading = true;

    this.httpApiService
      .post(
        `/accounts/${this.pledge.accountId}/pledges/${this.pledge.id}/subscription-completion`,
        this.pledge,
      )
      .subscribe(
        (result: any) => {},
        (error: any) => {
          console.error('Error:', error);
        },
      );
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
